function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This file is copy pasted from ../rise/colors
// The only difference between the files are the values of the blue primitive tokens
// Any changes made in ../rise/colors must be reflected here as well
import { rgbaWithOpacity } from '../utils';
export var primitiveTokens = {
  light1: 'rgba(255, 255, 255, 1)',
  light2: 'rgba(246, 248, 250, 1)',
  light3: 'rgba(235, 240, 245, 1)',
  light4: 'rgba(217, 225, 232, 1)',
  light5: 'rgba(166, 185, 201, 1)',
  light6: 'rgba(116, 144, 170, 1)',
  light7: 'rgba(55, 83, 108, 1)',
  light8: 'rgba(31, 52, 71, 1)',
  light9: 'rgba(11, 22, 32, 1)',
  dark1: 'rgba(17, 25, 32, 1)',
  dark2: 'rgba(29, 40, 50, 1)',
  dark3: 'rgba(40, 53, 64, 1)',
  dark4: 'rgba(55, 69, 82, 1)',
  dark5: 'rgba(79, 94, 107, 1)',
  dark6: 'rgba(101, 115, 128, 1)',
  dark7: 'rgba(155, 171, 186, 1)',
  dark8: 'rgba(195, 211, 224, 1)',
  dark9: 'rgba(255, 255, 255, 1)',
  blue1: 'rgba(209, 244, 255, 1)',
  blue2: 'rgba(123, 220, 248, 1)',
  blue3: 'rgba(46, 196, 241, 1)',
  blue4: 'rgba(0, 173, 239, 1)',
  blue5: 'rgba(0, 156, 235, 1)',
  blue6: 'rgba(0, 137, 225, 1)',
  blue7: 'rgba(0, 110, 196, 1)',
  blue8: 'rgba(0, 66, 123, 1)',
  blue9: 'rgba(0, 28, 54, 1)',
  blueAccessible1: 'rgba(235, 245, 255, 1)',
  blueAccessible2: 'rgba(194, 224, 255, 1)',
  blueAccessible3: 'rgba(112, 187, 255, 1)',
  blueAccessible4: 'rgba(71, 168, 255, 1)',
  blueAccessible5: 'rgba(0, 118, 224, 1)',
  blueAccessible6: 'rgba(0, 86, 163, 1)',
  blueAccessible7: 'rgba(0, 64, 122, 1)',
  blueAccessible8: 'rgba(0, 43, 82, 1)',
  blueAccessible9: 'rgba(0, 21, 41, 1)',
  green1: 'rgba(205, 255, 234, 1)',
  green2: 'rgba(105, 246, 188, 1)',
  green3: 'rgba(17, 225, 139, 1)',
  green4: 'rgba(0, 191, 111, 1)',
  green5: 'rgba(0, 146, 85, 1)',
  green6: 'rgba(0, 102, 59, 1)',
  green7: 'rgba(0, 67, 39, 1)',
  green8: 'rgba(0, 47, 27, 1)',
  green9: 'rgba(0, 38, 22, 1)',
  red1: 'rgba(255, 207, 221, 1)',
  red2: 'rgba(252, 187, 206, 1)',
  red3: 'rgba(241, 139, 169, 1)',
  red4: 'rgba(222, 67, 114, 1)',
  red5: 'rgba(196, 0, 59, 1)',
  red6: 'rgba(163, 0, 49, 1)',
  red7: 'rgba(126, 0, 38, 1)',
  red8: 'rgba(87, 0, 26, 1)',
  red9: 'rgba(54, 0, 16, 1)',
  gold1: 'rgba(255, 242, 224, 1)',
  gold2: 'rgba(251, 218, 174, 1)',
  gold3: 'rgba(239, 188, 120, 1)',
  gold4: 'rgba(219, 155, 70, 1)',
  gold5: 'rgba(191, 121, 30, 1)',
  gold6: 'rgba(155, 90, 6, 1)',
  gold7: 'rgba(144, 65, 0, 1)',
  gold8: 'rgba(72, 41, 0, 1)',
  gold9: 'rgba(36, 20, 0, 1)'
};
export var globalTokens = {
  neutralLight1: primitiveTokens.light1,
  neutralLight2: primitiveTokens.light2,
  neutralLight3: primitiveTokens.light3,
  neutralLight4: primitiveTokens.light4,
  neutralLight5: primitiveTokens.light5,
  neutralLight6: primitiveTokens.light6,
  neutralLight7: primitiveTokens.light7,
  neutralLight8: primitiveTokens.light8,
  neutralLight9: primitiveTokens.light9,
  neutralDark1: primitiveTokens.dark1,
  neutralDark2: primitiveTokens.dark2,
  neutralDark3: primitiveTokens.dark3,
  neutralDark4: primitiveTokens.dark4,
  neutralDark5: primitiveTokens.dark5,
  neutralDark6: primitiveTokens.dark6,
  neutralDark7: primitiveTokens.dark7,
  neutralDark8: primitiveTokens.dark8,
  neutralDark9: primitiveTokens.dark9,
  blueLight: primitiveTokens.blue2,
  blueBrand: primitiveTokens.blue3,
  bluePrimary: primitiveTokens.blue5,
  blueHighlight: primitiveTokens.blue6,
  blueDark: primitiveTokens.blue8,
  blueAccessibleLight: primitiveTokens.blueAccessible2,
  blueAccessibleBrand: primitiveTokens.blueAccessible3,
  blueAccessiblePrimary: primitiveTokens.blueAccessible5,
  blueAccessibleHighlight: primitiveTokens.blueAccessible6,
  blueAccessibleDark: primitiveTokens.blueAccessible8,
  greenLight: primitiveTokens.green2,
  greenPrimary: primitiveTokens.green5,
  greenDark: primitiveTokens.green8,
  redLight: primitiveTokens.red2,
  redPrimary: primitiveTokens.red5,
  redDark: primitiveTokens.red8,
  goldLight: primitiveTokens.gold2,
  goldPrimary: primitiveTokens.gold5,
  goldDark: primitiveTokens.gold8
};
export var functionalTokens = {
  light: {
    // Backgrounds
    bgPrimary: globalTokens.neutralLight1,
    bgSecondary: globalTokens.neutralLight2,
    bgAlternate: globalTokens.blueAccessiblePrimary,
    bgActionPrimary: globalTokens.blueAccessiblePrimary,
    bgActionSecondary: globalTokens.neutralLight3,
    bgActionTertiary: rgbaWithOpacity(globalTokens.neutralLight1, 0),
    bgActionDisabledPrimary: globalTokens.blueAccessibleLight,
    bgPositivePrimary: globalTokens.greenPrimary,
    bgPositiveSecondary: globalTokens.greenLight,
    bgNegativePrimary: globalTokens.redPrimary,
    bgNegativeSecondary: globalTokens.redLight,
    bgWarningPrimary: globalTokens.goldPrimary,
    bgWarningSecondary: globalTokens.goldLight,
    bgTargetPrimary: globalTokens.blueAccessibleDark,
    bgTargetSecondary: globalTokens.neutralLight5,
    bgTargetTertiary: globalTokens.neutralLight3,
    bgHoverPrimary: globalTokens.blueAccessibleHighlight,
    bgHoverSecondary: globalTokens.neutralLight4,
    bgHoverTertiary: globalTokens.neutralLight3,
    bgAccent: globalTokens.blueAccessiblePrimary,
    bgCard: globalTokens.neutralLight9,
    bgElevated: globalTokens.neutralLight1,
    // Text
    textPrimary: globalTokens.neutralLight9,
    textSecondary: globalTokens.neutralLight8,
    textTertiary: globalTokens.neutralLight7,
    textPlaceholder: globalTokens.neutralLight6,
    textDisabled: globalTokens.neutralLight5,
    textInverted: globalTokens.neutralLight1,
    textActionPrimary: globalTokens.blueAccessiblePrimary,
    textActionSecondary: globalTokens.neutralLight9,
    textActionTertiary: globalTokens.neutralLight1,
    textActionDisabledPrimary: globalTokens.blueAccessibleLight,
    textActionDisabledSecondary: globalTokens.neutralLight1,
    textPositivePrimary: globalTokens.greenPrimary,
    textPositiveSecondary: globalTokens.greenDark,
    textNegativePrimary: globalTokens.redPrimary,
    textNegativeSecondary: globalTokens.redDark,
    textWarningPrimary: globalTokens.goldPrimary,
    textWarningSecondary: globalTokens.goldDark,
    // Structures
    borderPrimary: globalTokens.neutralDark5,
    borderActive: globalTokens.blueAccessiblePrimary,
    borderFocused: globalTokens.blueAccessibleLight,
    shadowPrimary: rgbaWithOpacity(globalTokens.neutralLight9, 0.12),
    shadowButton: rgbaWithOpacity(globalTokens.blueAccessiblePrimary, 0.32),
    overlay: rgbaWithOpacity(globalTokens.neutralLight9, 0.4),
    divider: globalTokens.neutralDark5,
    // DEPRECATED
    // Icons
    iconDefault: globalTokens.neutralLight9,
    iconSelected: globalTokens.blueAccessiblePrimary,
    iconPlaceholder: globalTokens.neutralLight6,
    iconDisabled: globalTokens.neutralLight5,
    iconInverted: globalTokens.neutralLight1,
    iconPositivePrimary: globalTokens.greenPrimary,
    iconPositiveSecondary: globalTokens.greenDark,
    iconNegativePrimary: globalTokens.redPrimary,
    iconNegativeSecondary: globalTokens.redDark,
    iconWarningPrimary: globalTokens.goldPrimary,
    iconWarningSecondary: globalTokens.goldDark,
    // Data Visualization
    data1: globalTokens.blueAccessiblePrimary,
    data2: globalTokens.blueAccessibleDark,
    data3: globalTokens.blueAccessibleBrand,
    data4: globalTokens.blueAccessibleLight,
    data5: globalTokens.blueAccessibleHighlight,
    data6: globalTokens.neutralLight7,
    data7: globalTokens.neutralLight5,
    dataPositive: globalTokens.greenPrimary,
    dataNegative: globalTokens.redPrimary,
    borderDefault: globalTokens.neutralLight3,
    fillLogo: globalTokens.neutralLight9
  },
  dark: {
    // Backgrounds
    bgPrimary: globalTokens.neutralDark1,
    bgSecondary: globalTokens.neutralDark2,
    bgAlternate: globalTokens.bluePrimary,
    bgActionPrimary: globalTokens.bluePrimary,
    bgActionSecondary: globalTokens.neutralDark3,
    bgActionTertiary: rgbaWithOpacity(globalTokens.neutralDark1, 0),
    bgActionDisabledPrimary: globalTokens.blueDark,
    bgPositivePrimary: globalTokens.greenPrimary,
    bgPositiveSecondary: globalTokens.greenLight,
    bgNegativePrimary: globalTokens.redPrimary,
    bgNegativeSecondary: globalTokens.redLight,
    bgWarningPrimary: globalTokens.goldPrimary,
    bgWarningSecondary: globalTokens.goldLight,
    bgTargetPrimary: globalTokens.blueDark,
    bgTargetSecondary: globalTokens.neutralDark5,
    bgTargetTertiary: globalTokens.neutralDark3,
    bgHoverPrimary: globalTokens.blueHighlight,
    bgHoverSecondary: globalTokens.neutralDark4,
    bgHoverTertiary: globalTokens.neutralDark3,
    bgAccent: globalTokens.bluePrimary,
    bgCard: globalTokens.neutralDark3,
    bgElevated: globalTokens.neutralDark4,
    // Text
    textPrimary: globalTokens.neutralDark9,
    textSecondary: globalTokens.neutralDark8,
    textTertiary: globalTokens.neutralDark7,
    textPlaceholder: globalTokens.neutralDark6,
    textDisabled: globalTokens.neutralDark5,
    textInverted: globalTokens.neutralDark9,
    textActionPrimary: globalTokens.bluePrimary,
    textActionSecondary: globalTokens.neutralDark9,
    textActionTertiary: globalTokens.neutralDark9,
    textActionDisabledPrimary: globalTokens.blueDark,
    textActionDisabledSecondary: globalTokens.neutralDark1,
    textPositivePrimary: globalTokens.greenLight,
    textPositiveSecondary: globalTokens.greenDark,
    textNegativePrimary: globalTokens.redLight,
    textNegativeSecondary: globalTokens.redDark,
    textWarningPrimary: globalTokens.goldLight,
    textWarningSecondary: globalTokens.goldDark,
    // Structures
    borderPrimary: globalTokens.neutralDark5,
    borderActive: globalTokens.bluePrimary,
    borderFocused: globalTokens.blueLight,
    shadowPrimary: rgbaWithOpacity(globalTokens.neutralDark1, 0.12),
    shadowButton: rgbaWithOpacity(globalTokens.bluePrimary, 0.32),
    overlay: rgbaWithOpacity(globalTokens.neutralLight9, 0.4),
    // DEPRECATED
    divider: globalTokens.neutralDark5,
    // Icons
    iconDefault: globalTokens.neutralDark9,
    iconSelected: globalTokens.bluePrimary,
    iconPlaceholder: globalTokens.neutralDark6,
    iconDisabled: globalTokens.neutralDark5,
    iconInverted: globalTokens.neutralDark9,
    iconPositivePrimary: globalTokens.greenLight,
    iconPositiveSecondary: globalTokens.greenDark,
    iconNegativePrimary: globalTokens.redLight,
    iconNegativeSecondary: globalTokens.redDark,
    iconWarningPrimary: globalTokens.goldLight,
    iconWarningSecondary: globalTokens.goldDark,
    // Data Visualization
    data1: globalTokens.bluePrimary,
    data2: globalTokens.blueDark,
    data3: globalTokens.blueBrand,
    data4: globalTokens.blueLight,
    data5: globalTokens.blueHighlight,
    data6: globalTokens.neutralDark7,
    data7: globalTokens.neutralDark5,
    dataPositive: globalTokens.greenLight,
    dataNegative: globalTokens.redLight,
    // legacy
    borderDefault: globalTokens.neutralDark3,
    // internal logo token
    fillLogo: globalTokens.blueBrand
  }
};
export var componentTokens = {
  light: {
    //CTA Backgrounds
    bgCTAPrimary: functionalTokens.light.bgActionPrimary,
    bgCTASecondary: functionalTokens.light.bgActionSecondary,
    bgCTATertiary: functionalTokens.light.bgActionTertiary,
    // CTA Text
    textCTAPrimary: functionalTokens.light.textActionTertiary,
    textCTASecondary: functionalTokens.light.textActionSecondary,
    textCTATertiary: functionalTokens.light.textActionSecondary,
    textCTAPrimaryDisabled: functionalTokens.light.textActionDisabledSecondary,
    textCTASecondaryDisabled: functionalTokens.light.textDisabled,
    textCTATertiaryDisabled: functionalTokens.light.textActionDisabledPrimary,
    // Text field Backgrounds
    bgTextFieldDefault: functionalTokens.light.bgActionSecondary,
    bgTextFieldActive: functionalTokens.light.bgActionTertiary,
    // Text field text
    textTextFieldDefault: functionalTokens.light.textPlaceholder,
    textTextFieldActive: functionalTokens.light.textActionSecondary,
    textTextFieldDisabled: functionalTokens.light.textDisabled,
    textTextFieldLabel: functionalTokens.light.textPrimary,
    textTextFieldCaption: functionalTokens.light.textTertiary
  },
  dark: {
    //CTA Backgrounds
    bgCTAPrimary: functionalTokens.dark.bgActionPrimary,
    bgCTASecondary: functionalTokens.dark.bgActionSecondary,
    bgCTATertiary: functionalTokens.dark.bgActionTertiary,
    // CTA Text
    textCTAPrimary: functionalTokens.dark.textActionTertiary,
    textCTASecondary: functionalTokens.dark.textActionSecondary,
    textCTATertiary: functionalTokens.dark.textActionSecondary,
    textCTAPrimaryDisabled: functionalTokens.dark.textActionDisabledSecondary,
    textCTASecondaryDisabled: functionalTokens.dark.textDisabled,
    textCTATertiaryDisabled: functionalTokens.dark.textActionDisabledPrimary,
    // Text field Backgrounds
    bgTextFieldDefault: functionalTokens.dark.bgActionSecondary,
    bgTextFieldActive: functionalTokens.dark.bgActionTertiary,
    // Text field text
    textTextFieldDefault: functionalTokens.dark.textPlaceholder,
    textTextFieldActive: functionalTokens.dark.textActionSecondary,
    textTextFieldDisabled: functionalTokens.dark.textDisabled,
    textTextFieldLabel: functionalTokens.dark.textPrimary,
    textTextFieldCaption: functionalTokens.dark.textTertiary
  }
};
export default {
  light: _objectSpread(_objectSpread({}, functionalTokens.light), componentTokens.light),
  dark: _objectSpread(_objectSpread({}, functionalTokens.dark), componentTokens.dark)
};